// extracted by mini-css-extract-plugin
export default {"iframe-modal":"iframeModal_iframe-modal__1Ewkj"};